import * as actionTypes from "../actionType/action-type";

const initialState = { projectFlag: false }

const PROJECT_FLAG = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.PROJECT_FLAG:
            return projectFlag(state, payload);
        default:
            return state;
    }
};

const projectFlag = (state, payload) => {
    let newState = {
        projectFlag: payload,
    };
    state = Object.assign({}, state, newState);
    return state;
};

export default PROJECT_FLAG;